import React, { useState } from 'react';
import {
  Container, Row, Col, Button, Form, Modal
} from 'react-bootstrap';
import Header from '../Header';
import Footer from '../Footer';
import { Link, useHistory } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import ActionButton from '../ActionButton';
import PrivacyModal from '../common/PrivacyModal';
import { staticData } from '../../helpers/data';
import { formatDate } from '../../helpers/utils';
import { Student } from '../../Services/Student';
import { sanitize, validateFormFields } from '../../utils/validationUtils';

function SignupStepThree({ nextStep, prevStep, handleFormData, values }) {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const validateForm = () => {
    const sanitizedData = {
      ...Object.keys(values).reduce((acc, key) => {
        acc[key] = sanitize(values[key]);
        return acc;
      }, {}),
      privacyAccepted
    };

    const errors = validateFormFields(sanitizedData, 'student');
    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      NotificationManager.error(Object.values(errors)[0], 'Form Error', 3000);
      return false;
    }

    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      formData.append(key, value);
    });

    Student.post(formData, 'student/register').then(
      (data) => {
        if (data.error === 0) {
          NotificationManager.success(data.message, 'Success', 2000);
          localStorage.setItem('student', JSON.stringify(data.data));
          setShowModal(true);
          setTimeout(() => history.push('/'), 5000);
        }
      },
      (error) => NotificationManager.error(error.toString(), 'Error', 2000)
    );
  };

  return (
    <>
      <Header />
      <section className="login-body" style={{ backgroundImage: 'url(\"images/signup-bg.jpg\")' }}>
        <Container>
          <Row>
            <Col md={12}>
              <div className="step-progress">
                <div className="step-progress-bar">
                  <div className="step-progress-percent" style={{ width: '50%' }}></div>
                </div>
                <div className="step-progress-text">
                  <h6>Parental Consent</h6>
                  <h6>50% Completed</h6>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={9}>
              <div className="signup-box">
                <div className="signup-left">
                  <h4>{staticData?.verbiage?.student[3]?.heading}</h4>
                  <p>{staticData?.verbiage?.student[3]?.text}</p>
                  <div className="signup-step">
                    <ul><li></li><li></li><li className="active"></li><li></li><li></li><li></li></ul>
                  </div>
                </div>
                <div className="signup-right">
                  <Form onSubmit={handleSubmit}>
                    <div className="add-details">
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="first_name" onChange={handleFormData("first_name")} defaultValue={values.first_name} placeholder="First Name*" />
                            <span className="err">{fieldErrors.first_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="last_name" onChange={handleFormData("last_name")} defaultValue={values.last_name} placeholder="Last Name*" />
                            <span className="err">{fieldErrors.last_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="tel" name="phone" onChange={handleFormData("phone")} defaultValue={values.phone} placeholder="School Main Phone Number" />
                            <span className="err">{fieldErrors.phone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Select name="timezone" onChange={handleFormData("timezone")} defaultValue={values.timezone}>
                              <option disabled value=''>Select Time Zone*</option>
                              <option value="EST">EST</option>
                              <option value="CST">CST</option>
                              <option value="PST">PST</option>
                            </Form.Select>
                            <span className="err">{fieldErrors.timezone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="email" name="email" onChange={handleFormData("email")} defaultValue={values.email} placeholder="Your School Email Address" />
                            <span className="err">{fieldErrors.email}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="email" name="guardian_email" onChange={handleFormData("guardian_email")} defaultValue={values.guardian_email} placeholder="Parent/Guardian Email Address" />
                            <span className="err">{fieldErrors.guardian_email}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <h6 className="text-muted">Privacy notice</h6>
                          <Button variant="link" className='text-primary' onClick={() => setShowPrivacyModal(true)}>Click here to read Privacy notice</Button>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="iagree mb-3">
                            <Form.Check type="checkbox" checked={privacyAccepted} onChange={(e) => setPrivacyAccepted(e.target.checked)} label={`I have read & accepted Dasya Privacy Notice as on ${formatDate()}`} />
                            <span className="err">{fieldErrors.privacyAccepted}</span>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                    <div className="signup-back-btn">
                      <Link onClick={prevStep} to="#" className="btn btn-link">Back</Link>
                      <ActionButton
  type="submit"
  className="btn btn-primary btn-pill px-4"
  title="Obtain Parental Consent"
  requiredFields={[
    values?.first_name,
    values?.last_name,
    values?.phone,
    values?.email,
    values?.guardian_email,
    values?.timezone,
    privacyAccepted ? 'true' : null
  ]}
/>
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />

      <Modal show={showModal} onHide={() => history.push('/')} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Consent Form Sent!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center my-4">
            <img src="images/mail-icon.png" alt="" width="110" />
          </div>
          <p className="modal-text text-center">
            We sent an email to {values?.guardian_email} to obtain parental consent. Kindly ask your parent/guardian to sign the consent form in order to complete your registration process.
          </p>
          <div className="text-center">
            <Button variant="primary" onClick={() => history.push('/')} className="px-5">
              Okay
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <PrivacyModal
        show={showPrivacyModal}
        privacyText={staticData?.privacyText?.admin}
        handleClose={() => setShowPrivacyModal(false)}
      />
    </>
  );
}

export default SignupStepThree;
